/** A marca dos guias, no servidor (SPEC-FE-008). */

import { http } from "@/lib/http";
import type { components } from "@/lib/api-types";

export type EstadoDoGuia = "concluido" | "pulado";

/** O contrato tipa `vistos` como `Record<string, string>` (o Pydantic da
 * rota não usa `Literal`); o front sempre assumiu só os dois estados que ele
 * próprio grava. */
export type GuiasVistos = Omit<components["schemas"]["GuiasResponse"], "vistos"> & {
  vistos: Record<string, EstadoDoGuia>;
};

export function buscarGuias(): Promise<GuiasVistos> {
  return http.get<GuiasVistos>("/users/me/guias");
}

// `<undefined>` e não `<void>`: as rotas respondem `204`, e o cliente devolve
// `undefined` — é o mesmo padrão das outras escritas sem corpo (etiquetas,
// membros), e `void` como argumento de tipo o ESLint recusa com razão.
export async function marcarGuia(tela: string, estado: EstadoDoGuia): Promise<void> {
  await http.put<undefined>(`/users/me/guias/${encodeURIComponent(tela)}`, { estado });
}

export async function mudarGuias(desligado: boolean): Promise<void> {
  await http.put<undefined>("/users/me/guias", { desligado });
}
